import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { Loader, Table } from 'rsuite'
import { useHistory } from 'react-router-dom'
import ExcelJS from 'exceljs';
import PreviewTable from './preview-table'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import ToggleButton from '../CommonComponents/ToggleButton'
import ByPassModal from './modal/bypass-modal'
import { checkIsAdmin, checkIsAdminOrModerator, getAbbreviatedState, getCardGenericFeeDataForImport, getCardSpecificFeeDataForImport, getFeeValue } from '../../services/helper'
import VendorExportModal from '../AssignVendorComponent/modals/export-modal'
import { validationFields, validationCols, bulkUpdateMasterColumnsValues } from '../../utils/constants/reportFilters'
import { annualizedPaymentCount } from '../../utils/validator/index'

import {
  uploadFinalData,
  clearUploadData,
  dbMatch,
  bulkUpdatSupplierData,
  importFileData,
  uploadFinalDataFailed,
  uploadFinalDataStart,
  uploadData,
  matchUploadedData,
  uploadFileUsingMulter
} from '../../redux/actions/upload'

import {
  setSpendDuration,
  updateDataSource,
} from '../../redux/actions/app'

import {
  convertUploadedVendorData,
  validateFieldValue,
  convertValueForType,
  calcAnnualizedSpend,
  formatEmployerIdNumber,
  validateLinkedField
} from '../../utils/validator/index'

import {
  isDiffTwoObj,
  splitArrayInToChunks
} from '../../services/helper'

import { toast } from '../../components/CommonComponents/ToastComponent/toast'
import SpendInfoModal from './modal/spend-modal'
import { addSupplierHistory } from '../../redux/actions//vendor'
import ModalComponent from '../CommonComponents/Modal'
import Pako from 'pako';

const { Pagination } = Table
const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB chunks

let tableEditedData = []

const PreviewComponent = ({ onGoBack, dbMatchValues, isTest = false, onConfirm, selectedSupplierType, originalFile, colWithStatus }) => {
  const history = useHistory()
  const store = useStore().getState()
  const dispatch = useDispatch()

  const [limit, setLimit] = React.useState(10)
  const [page, setPage] = React.useState(1)
  const [showByPassModal, setShowByPassModal] = React.useState(false)
  const [doByPass, setDoByPass] = React.useState(true)
  const cardVariableFeeCols = ['isAcceptAmexVariableFee', 'isAcceptVisaVariableFee', 'isAcceptMasterCardVariableFee']
  const cardProcessingFeeCols = ['amexProcessingFeeValue', 'visaProcessingFeeValue', 'mastercardProcessingFeeValue']
  const cardMinFeeCols = ['amexMinPaymentFeeValue', 'visaMinPaymentFeeValue', 'mastercardMinPaymentFeeValue']
  const cardMaxFeeCols = ['amexMaxPaymentFeeValue', 'visaMaxPaymentFeeValue', 'mastercardMaxPaymentFeeValue']
  const cardIncrementalFeeCols = ['amexIncrementalFeeValue', 'visaIncrementalFeeValue', 'mastercardIncrementalFeeValue']
  const cardMinPaymentColumns = ['americanExpressMinPaymnet', 'visaMinPayment', 'mastercardMinPayment']
  const cardMaxPaymentColumns = ['americanExpressMaxPayment', 'visaMaxPayment', 'mastercardMaxPayment']
  const cardIncrementalPaymentColumns = ['amexIncrementalPaymentAmount', 'visaIncrementalPaymentAmount', 'mastercardIncrementalPaymentAmount']
  const [exportErrorColumn, setExportErrorColumn] = React.useState([])
  const [validData, setValidData] = useState([])
  const [invalidData, setInvalidData] = useState([])

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  }

  const {
    upload: { matchedData, isUploading, isDBMatching, uploadedData },
    app: {
      uploadAllVendorColumns,
      uploadSupplierDetailColumns,
      cardColumns,
      paymentColumns,
      merchantColumns,
      currentDataSource,
      spendTimeFrame,
      spendTimeType,
      supplierAllColumns,
      createSupplierCardColumns
    },
    auth: { user },
    domain: {
      currentDomain,
    },
    partner: { partnerNames }
  } = store

  const searchColumns = [
    {
      name: 'suppliername',
      label: 'Supplier Name'
    },
    {
      name: 'address1',
      label: 'Address Line 1'
    },
    {
      name: 'city',
      label: 'City'
    },
    {
      name: 'state',
      label: 'State'
    },
    {
      name: 'zip',
      label: 'Zip'
    },
    {
      name: 'email',
      label: 'Email'
    },
  ]

  const isAdmin = checkIsAdmin(currentDomain)
  const isAdminOrModerator = checkIsAdminOrModerator(currentDomain)
  const [previewColumns, setPreviewColumns] = useState([])
  const [oldTableData, setOldTableData] = useState([])
  const [tableData, setTableData] = useState([])
  const [tableHeader, setTableHeader] = useState([])
  const [searchList, setSearchList] = useState([])
  const [editingIds, setEditingIds] = useState([])
  const [showOnlyIssuedRows, setShowOnlyIssuedRows] = useState(false)
  const [showOnlyModifiedRows, setShowOnlyModifiedRows] = useState(false)
  const [showAllImportableColumns, setShowAllImportableColumns] = useState(false)
  const [showFileError, setShowFileError] = useState(false)
  const [countInvalidRecords, setCountInvalidRecords] = useState(0)
  const [processedRecords, setProcessedRecords] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [startIndexData, setStartIndexData] = useState(0);

  useEffect(() => {
    if (uploadedData) {
      setProcessedRecords(uploadedData.processedRows);
      setTotalRecords(uploadedData.totalRows);
    }
  }, [uploadedData]);

  // Duration of spend modal
  const [showModal, setShowModal] = useState(false)
  useEffect(() => {
    if (!currentDataSource || currentDataSource.columns.length === 0) {
      return
    }

    if (!matchedData || !matchedData.cols || !matchedData.cols.length === 0) {
      return
    }

    const uploadVendorColumnsForDataSource = currentDataSource && uploadAllVendorColumns?.filter(vendorColumn => currentDataSource?.columns?.includes(vendorColumn.name))
    if (currentDataSource?.value === 'bulkUpdate') {
      setPreviewColumns([...currentDataSource?.columns])
    } else if (!showAllImportableColumns) {
      setPreviewColumns([...uploadVendorColumnsForDataSource.filter(column => matchedData.cols.findIndex(col => col.matchedName === column.name && col.confirm === 2) !== -1)])
    } else {
      setPreviewColumns([...uploadVendorColumnsForDataSource])
    }
  }, [matchedData, currentDataSource, uploadAllVendorColumns, showAllImportableColumns])

  useEffect(() => {
    if (!matchedData || !matchedData.data) {
      return
    }
    if (!previewColumns || previewColumns.length === 0) {
      return
    }

    const filteredData = matchedData.data.filter(row => {
      let status = true
      if (searchList.length > 0) {
        searchList.forEach(searchItem => {
          const strFieldValue = row[searchItem.colName]?.toString()?.toUpperCase()
          const strSearch = searchItem.searchKey?.toString()?.toUpperCase()
          if (strSearch !== "" && !strFieldValue?.includes(strSearch)) {
            status = false
          }
        })
      }
      return status
    })
    const tData = convertUploadedVendorData(filteredData, spendTimeFrame, spendTimeType, isAdmin, currentDataSource?.value, selectedSupplierType).map((row, index) => {
      let t = {
        id: index,
        changed: false,
        validated: true,
      }
      for (let key in row) {
        let c = previewColumns.filter(col => col.name === key)[0]
        if (c && c.name) {
          if (!row[key].validate) {
            t['validated'] = false
          }
          if (c.dataType === 'boolean' && c.type === 'threestate') {
            t[c.name] = row[key].value
          } else {
            t[c.name] = row[key].value !== null || row[key].value !== undefined ? row[key].value : ''
          }
          // t[c.name] = row[key].value !== null || row[key].value !== undefined ? row[key].value : ''
        }
      }
      return t
    })

    const hData = previewColumns.map(col => (
      {
        ...col,
        matchedName: col.name,
        required: col.required,
      }
    ))

    if (currentDataSource?.value === 'bulkUpdate') {
      const hasPlaceholder = (value) => {
        const placeholders = ["#", "string", "example@gmail.com", "true/false"];
        return placeholders.some(placeholder => String(value).includes(placeholder));
      };
      const shouldRemoveFirstElement = Object.values(tData[0]).some(hasPlaceholder);
      if (shouldRemoveFirstElement) {
        tData.shift();
      }
    }

    const oldTData = JSON?.parse(JSON?.stringify(tData))
    setOldTableData([...oldTData])
    setTableData([...tData])
    setTableHeader(hData)
    // eslint-disable-next-line
  }, [matchedData, previewColumns, searchList, spendTimeFrame, spendTimeType])

  const countAndFilterInvalidRecords = () => {
    let invalidRecords = []
    let validRecords = []
    let countInvalidRecords = 0
    let doBypassData;
    tableData.forEach(row => {
      if (!row.validated) {
        invalidRecords.push(row)
        ++countInvalidRecords
      } else if ((row.hasOwnProperty('address1') && !row.address1) || (row.hasOwnProperty('city') && !row.city) || (row.hasOwnProperty('state') && !row.state) || (row.hasOwnProperty('zip') && !row.zip)) {
        doBypassData = true
        validRecords.push(row)
      } else if (row.hasOwnProperty('suppliername') && (!row.suppliername || row.suppliername === '' || row.suppliername === null || row.suppliername === undefined)) {
        doBypassData = false
        invalidRecords.push(row)
        ++countInvalidRecords
      } else {
        validRecords.push(row)
      }
    })

    return {
      invalidRecords,
      validRecords,
      countInvalidRecords,
      doBypassData
    }
  }

  const convertToArrayOfArrays = (data) => {
    if (data.length === 0) return [];
    let headers = Object.keys(data[0]).filter(head => {
      if (head === 'changed' || head === 'validated' || head === 'id') {
        return;
      }
      return head;
    });
    const values = data.map(obj => {
      return headers.map(header => {
        let value = obj[header];
        if (currentDataSource?.value === 'bulkUpdate' && selectedSupplierType === 'master') {
          const columnConfig = bulkUpdateMasterColumnsValues[header];
          if (columnConfig && columnConfig.dataType === 'boolean') {
            if (value === 0) {
              value = 'FALSE';
            } else if (value === 1) {
              value = 'TRUE';
            }
          }
        }

        if (header?.toLowerCase() === 'childqastatus' || header?.toLowerCase() === 'masterqastatus') {
          value = value === 8 ? 'Approved' : value === 7 ? 'Rejected' : (value === 6 || value === null || !value) ? 'Pending' : "In Calls";
        }

        return value ? `"${value?.toString()?.trim()?.replace(/(?:\\[rn]|[\r\n])/g, " ")}"` : '';
      })
    });

    return [headers, ...values];
  };

  const fileValidationHandler = async () => {
    let data = countAndFilterInvalidRecords()
    if (data?.countInvalidRecords > 0) {
      if (currentDataSource?.value === 'bulkUpdate') {
        const validateField = []
        data?.invalidRecords.forEach((row, index) => {
          validateField[index] = validateField[index] || [];
          for (const column of previewColumns) {
            if (validationCols.includes(column.name)) {
              if (!validateLinkedField(row, column, validationFields)) {
                validateField[index].push(column.name);
              }
            }
          }
        });
        setExportErrorColumn(validateField)
      }

      let updatedData = convertToArrayOfArrays(data?.invalidRecords)
      if (data?.countInvalidRecords > 0) {
        setShowFileError(true)
      }
      setCountInvalidRecords(data?.countInvalidRecords)
      setValidData(data?.validRecords)
      setInvalidData(updatedData)
    } else {
      if (currentDataSource?.value === 'list') {
        dispatchDbMatch(data?.validRecords)
      } else {
        dispatchFinalData(data?.validRecords, false)
      }
    }
  }

  const exportInvalidRecords = async () => {
    if (currentDataSource?.value === 'bulkUpdate' && selectedSupplierType === 'master') {
      const colorMap = [...exportErrorColumn];
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Invalid Suppliers');
      const bulkUpdateHeader = Object.keys(bulkUpdateMasterColumnsValues);
      invalidData[0] = bulkUpdateHeader;
      invalidData.forEach((row, rowIndex) => {
        const worksheetRow = worksheet.addRow(row.map(cell =>
          typeof cell === 'string' ? cell.replace(/^"|"$/g, '') : cell
        ));

        if (rowIndex > 0) {
          const columnsToColor = colorMap[rowIndex - 1];
          if (columnsToColor) {
            columnsToColor.forEach((columnName) => {
              const columnIndex = invalidData[0].indexOf(columnName);
              if (columnIndex !== -1) {
                const cell = worksheetRow.getCell(columnIndex + 1);
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFFFFF00' },
                };
              }
            });
          }
        }
      });

      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const downloadElement = document.createElement('a');
      downloadElement.setAttribute('href', url);
      downloadElement.setAttribute('download', 'Invalid_Suppliers.xlsx');
      downloadElement.click();

      window.URL.revokeObjectURL(url);
    } else {
      let csvContent = ""
      invalidData.forEach((row, index) => {
        const dataString = row.join(',')
        csvContent += index < invalidData?.length ? dataString + '\n' : dataString
      })
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      const downloadElement = document.createElement('a');
      downloadElement.setAttribute('href', url)
      downloadElement.setAttribute('download', `${'Invalid Suppliers' || 'supplier'}.csv`)
      downloadElement.click()
    }
    setShowFileError(false)

    if (currentDataSource?.value === 'list') {
      dispatchDbMatch(validData)
    } else {
      dispatchFinalData(validData, false)
    }
  }

  const skipTableRecord = async () => {
    if (uploadedData.processedRows < uploadedData.totalRows) {
      dispatch(uploadFinalDataStart());
      try {
        const filterDataNew = await handleFileChosen(originalFile);
        dispatch(
          uploadData({
            cols: filterDataNew.cols,
            data: filterDataNew.subsetTableData,
            fileName: filterDataNew.fileName,
            processedRows: filterDataNew.processedRows,
            totalRows: uploadedData.totalRows,
            uploadedListId: uploadedData.uploadedListId,
            mainFileName: uploadedData.mainFileName
          })
        );
        setProcessedRecords(filterDataNew.processedRows);
        dispatch(
          matchUploadedData(colWithStatus)
        );
        toast.show({
          title: 'Skipped',
          description: `Record Skipped`
        });

      } catch (error) {
        console.error('Error skipping chunk:', error);
        toast.show({
          title: 'Error',
          description: 'Failed to skip to next chunk'
        });
      } finally {
        dispatch(uploadFinalDataFailed());
      }
    } else {
      dispatch(uploadFinalDataFailed())
      dispatch(
        clearUploadData()
      )
      updateDataSource(null)
      if (currentDataSource?.value === 'bulkUpdate') {
        history.push({
          pathname: '/suppliers',
          state: { isJustFileUploaded: true },
        })
      }
      if (currentDataSource?.value === 'list') {
        history.push({
          pathname: '/lists'
        })
      }
    }
  };

  const handleUploadFinalData = () => {
    let isAllValidated = true
    let doBypassData;

    let data = countAndFilterInvalidRecords()
    if (data?.countInvalidRecords > 0) {
      toast.show({
        title: 'Warning',
        description: 'There is Validation Error!'
      })
      return
    }

    if (currentDataSource?.value === 'list') {
      dispatchDbMatch(data?.validRecords)
    } else {
      dispatchFinalData(data?.validRecords, false)
    }
  }

  const handleChange = useCallback((id, key, dataType, value) => {
    if (key === 'employerIdNumber' && value) {
      value = formatEmployerIdNumber(value);
    }
    if (dataType === 'url' && value) {
      const regex = /^(?:[a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
      if (value && !value?.startsWith('https://') && !value?.startsWith('http://') && !value?.startsWith('www.')) {
        if (regex.test(value)) {
          value = 'www.' + value;
        }
      }
    }
    const convertedValue = convertValueForType(value, (key === 'zip' || key === 'checkZip') ? key : dataType);
    if (tableEditedData?.findIndex(item => item.id === id) !== -1) {
      tableEditedData.find(item => item.id === id)[key] = convertedValue;
      if (convertedValue !== oldTableData.find(row => row.id === id)[key]) {
        tableEditedData.find(item => item.id === id)['changed'] = true;
      } else {
        tableEditedData.find(item => item.id === id)['changed'] = isDiffTwoObj(
          { ...tableEditedData.find(item => item.id === id), changed: false },
          { ...oldTableData.find(row => row.id === id), changed: false }
        );
      }
    } else {
      const newObj = tableData?.find(row => row.id === id);
      if (oldTableData?.find(row => row.id === id)[key] !== convertedValue) {
        newObj['changed'] = true;
      }
      newObj[key] = convertedValue;
      tableEditedData = [...tableEditedData, newObj];
    }

    if (key === 'spend') {
      if (!spendTimeFrame || spendTimeFrame === '' || !spendTimeType) {
        handleShowModal();
      }
      const currentRow = tableEditedData?.find(row => row.id === id);
      currentRow['annualizedSpend'] = calcAnnualizedSpend(currentRow['spend'], spendTimeFrame || 1, spendTimeType?.value || 'year');
    }

    if (key === 'paymentCount') {
      const currentRow = tableEditedData?.find(row => row.id === id);
      currentRow['paymentCount'] = annualizedPaymentCount(spendTimeFrame, spendTimeType, currentRow['paymentCount']);
    }

    if (key === 'lastInvoiceNumber') {
      const currentRow = tableEditedData?.find(row => row.id === id);
      currentRow['lastInvoiceNumber'] = currentRow['lastInvoiceNumber']
    }

    let isValidated = true;
    let requiredFields = ['address1', 'city', 'state', 'zip'];
    previewColumns.every(column => {
      if (currentDataSource?.value === 'bulkUpdate' && validationCols.includes(column.name)) {
        if (!validateLinkedField(tableEditedData.find(item => item.id === id), column, validationFields)) {
          isValidated = false;
          return false;
        }
      } else if (column.name === 'phone' || column.name === 'cardPaymentByPhoneValue') {
        let phoneValue = tableEditedData?.find(item => item.id === id)[column.name];
        let isExt = phoneValue && phoneValue.toString().match(/x|ext|ext./);
        if (isExt && isExt.length > 0) {
          let parsePhone = phoneValue.split(isExt[0]);
          phoneValue = parsePhone[0].trim();
        }
        if (!validateFieldValue(column, phoneValue)) {
          isValidated = false;
          return false;
        }
      } else {
        if (isAdmin && requiredFields.includes(column.name) && !tableEditedData?.find(item => item.id === id)[column.name]) {
          isValidated = true;
        } else {
          if (!validateFieldValue(column, tableEditedData?.find(item => item.id === id)[column.name], isAdmin)) {
            isValidated = false;
            return false;
          }
        }
      }
      return true;
    });

    tableEditedData.find(item => item.id === id).validated = isValidated;
  }, [previewColumns, tableData, oldTableData, spendTimeFrame, spendTimeType]);

  const handleEditState = useCallback((id) => {
    let nextData = Object.assign([], tableData)
    if (editingIds && editingIds.includes(id)) {
      setEditingIds([...editingIds.filter(editingId => editingId !== id)])
      if (tableEditedData && tableEditedData.length > 0) {
        const editedRow = tableEditedData.find(row => row.id === id)
        const oldItem = nextData.find(row => row.id === id)
        const index = nextData.findIndex(row => row.id === id)
        if (index !== -1) {
          nextData[index] = {
            ...oldItem,
            ...editedRow
          }
        }
      }
      tableEditedData = [...tableEditedData.filter(row => row.id !== id)]
      setTableData(nextData)
    } else {
      setEditingIds([...editingIds, id])
      const oldItem = nextData.find(row => row.id === id)
      tableEditedData = [...tableEditedData, oldItem]
    }
  }, [tableData, editingIds])

  // click show only rows with problem
  const handleChangeProblemToggle = (checked) => {
    setShowOnlyIssuedRows(checked)
    setPage(1)
  }

  // show modification
  const handleChangeModifiedToggle = (checked) => {
    setShowOnlyModifiedRows(checked)
    setPage(1)
  }

  // show all importable columns
  const handleChangeImportableToggle = (checked) => {
    setShowAllImportableColumns(checked)
    setPage(1)
  }

  const handleSaveEdit = () => {
    let nextData = Object.assign([], tableData)
    if (tableEditedData && tableEditedData.length > 0) {
      tableEditedData.forEach(editedRow => {
        let index = nextData.findIndex(row => row.id === editedRow.id)
        const oldItem = nextData.find(row => row.id === editedRow.id)
        if (index !== -1) {
          nextData[index] = {
            ...oldItem,
            ...editedRow
          }
        }
      })
    }
    setTableData(nextData)
  }

  const handleCancelEdit = () => {
    tableEditedData = []
  }

  const handleChangeSearch = (searchKey, colName) => {
    const tmpSearchList = [...searchList]
    const existingIndex = tmpSearchList.findIndex(searchItem => searchItem.colName === colName)
    if (existingIndex !== -1) {
      tmpSearchList[existingIndex].searchKey = searchKey
    } else {
      tmpSearchList.push({
        colName: colName,
        searchKey: searchKey,
      })
    }
    setSearchList(tmpSearchList)
  }

  const handleClickRemoveSearch = () => {
    setSearchList([])
  }

  const handleShowModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleSetSpendDuration = (timeFrame, timeType) => {
    dispatch(
      setSpendDuration({
        spendTimeFrame: timeFrame,
        spendTimeType: timeType,
      })
    )
    setShowModal(false)
  }

  const filteredTableData = tableData?.filter(row => {
    let isFiltered = true
    if (showOnlyIssuedRows) {
      isFiltered = !row.validated
    }
    if (showOnlyModifiedRows) {
      isFiltered = isFiltered && row.changed
    }
    return isFiltered
  }).slice(limit * (page - 1), limit * page)

  const tableLength = tableData?.filter(row => {
    let isFiltered = true
    if (showOnlyIssuedRows) {
      isFiltered = !row.validated
    }
    if (showOnlyModifiedRows) {
      isFiltered = isFiltered && row.changed
    }
    return isFiltered
  })?.length


  const ByPassModalClose = () => {
    setShowByPassModal(false)
  }

  const ByPassModalConfirm = () => {
    if (currentDataSource?.value === 'list') {
      dispatchDbMatch()
    } else {
      dispatchFinalData(true)
    }
    // dispatchFinalData(false, true)
  }

  const dispatchFinalData = async (data, confirmByPass) => {
    let isAllValidated = true
    let phoneValid = true
    let isGenericFeeValid = true

    const tmpData = data.map(row => {
      const tmpSupplierData = {}
      let supplierId = '';
      let returnData = {};
      if (currentDataSource?.value === 'bulkUpdate' && selectedSupplierType === 'child') {
        returnData = {
          'childSupplierId': row?.['childSupplierId'],
          'masterSupplierId': row?.['masterId']
        }
      } else {
        if (currentDataSource?.value === 'bulkUpdate') {
          supplierId = row?.['masterSupplierId']
        }
        supplierAllColumns.forEach(column => {
          if (column.name === 'autoCreateMaster' && currentDomain?.roleId !== 3 && currentDomain?.roleName !== 'admin' && currentDomain?.roleId !== 2 && currentDomain?.roleName !== 'moderator') {
            return
          }

          if (column.name === 'phone') {
            let isExt = row[column.name] && row[column.name].toString().match(/x|ext|ext./)
            if (isExt && isExt.length > 0) {
              let parsePhone = row[column.name].split(isExt[0])
              tmpSupplierData[column.name] = parsePhone[0].trim()
              tmpSupplierData['phoneExtension'] = parsePhone[1].replace('.', '')
            } else {
              tmpSupplierData[column.name] = row[column.name]
              tmpSupplierData['phoneExtension'] = ''
            }
            if (tmpSupplierData[column.name] && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpSupplierData[column.name]) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(tmpSupplierData[column.name]) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(tmpSupplierData[column.name]))) {
              isAllValidated = false
              confirmByPass = false
              phoneValid = false
            }
          } else if (column.name === 'state') {
            tmpSupplierData[column.name] = row[column.name]
            let stateCode = getAbbreviatedState(row?.abbreviatedState, row?.state)
            tmpSupplierData['abbreviatedState'] = stateCode
          } else {
            tmpSupplierData[column.name] = row[column.name]
          }
        })

        const tmpSupplierDetailData = {}
        if (currentDataSource?.value !== 'bulkUpdate') {
          uploadSupplierDetailColumns.forEach(column => {
            if (column.name === 'contactDate') {
              if (typeof row[column.name] == 'string' && row[column.name].indexOf('/') !== -1) {
                tmpSupplierDetailData[column.name] = row[column.name]
              }
              else {
                if (row[column.name] === undefined)
                  tmpSupplierDetailData[column.name] = ''
                else {
                  var utc_days = Math.floor(row[column.name] - 25569);
                  var utc_value = utc_days * 86400;
                  var date_info = new Date(utc_value * 1000);

                  var fractional_day = row[column.name] - Math.floor(row[column.name]) + 0.0000001;

                  var total_seconds = Math.floor(86400 * fractional_day);

                  var seconds = total_seconds % 60;

                  total_seconds -= seconds;

                  tmpSupplierDetailData[column.name] = `${date_info.getUTCFullYear()}/${date_info.getUTCMonth() + 1}/${date_info.getUTCDate()}`
                }
              }
            } else {
              tmpSupplierDetailData[column.name] = row[column.name]
            }
          })
          if (row['spend'] && (!spendTimeType || !spendTimeFrame)) {
            handleShowModal()
            isAllValidated = false
          }
          tmpSupplierDetailData['spend'] = row['spend'];
          tmpSupplierDetailData['annualizedSpend'] = row['spend'] ? parseFloat(row['spend'] * spendTimeType?.rate / spendTimeFrame) : 0
          tmpSupplierDetailData['paymentCount'] = row['paymentCount'] ? parseFloat(annualizedPaymentCount(spendTimeFrame, spendTimeType, row['paymentCount'])) : 0
          tmpSupplierDetailData['lastInvoiceNumber'] = row['lastInvoiceNumber'] ? row['lastInvoiceNumber'] : null
          tmpSupplierDetailData['spendTimeFrame'] = spendTimeFrame
          tmpSupplierDetailData['spendTimeType'] = spendTimeType?.value
        } else {
          if (selectedSupplierType === 'master') {
            tmpSupplierDetailData['approvedByQA'] = row?.['approvedByQA']
          }
        }

        const tmpCardData = {}
        const cardColumnName = currentDataSource?.value === 'bulkUpdate' ? [...createSupplierCardColumns] : [...cardColumns]
        cardColumnName.forEach(column => {
          if (column.name === 'isAcceptVariableFee') {
            return
          }
          if (column.name === 'cardPaymentByPhoneValue') {
            let isExt = row[column.name] && row[column.name].toString().match(/x|ext|ext./)
            if (isExt && isExt.length > 0) {
              let parsePhone = row[column.name].split(isExt[0])
              tmpCardData[column.name] = parsePhone[0].trim()
              tmpCardData['cardPhoneExtension'] = parsePhone[1].replace('.', '')
            } else {
              tmpCardData[column.name] = row[column.name]
              tmpCardData['cardPhoneExtension'] = ''
            }
            if (tmpCardData[column.name]) {
              if ((!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpCardData[column.name]) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(tmpCardData[column.name]) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(tmpCardData[column.name]))) {
                isAllValidated = false
                confirmByPass = false
                phoneValid = false
              }
              tmpCardData['isAcceptPOTSPhone'] = 1
            }
          } else if (cardVariableFeeCols.includes(column.name) && row.hasOwnProperty('isAcceptVariableFee')) {
            tmpCardData[column.name] = row['isAcceptVariableFee']
          } else if (cardMinPaymentColumns.includes(column.name) && row.hasOwnProperty('genericMinPayment')) {
            var value = getFeeValue(row['genericMinPayment'])
            tmpCardData[column.name] = value
          } else if (cardMaxPaymentColumns.includes(column.name) && row.hasOwnProperty('genericMaxPayment')) {
            var value = getFeeValue(row['genericMaxPayment'])
            tmpCardData[column.name] = value
          } else if (cardIncrementalPaymentColumns.includes(column.name) && row.hasOwnProperty('genericIncrementalPayment')) {
            var value = getFeeValue(row['genericIncrementalPayment'])
            tmpCardData[column.name] = value
          } else if (column.name === 'isAcceptCardPaymentByOnlinePortal') {
            let colVal = 0;
            if (row.hasOwnProperty('isAcceptCardPaymentByOnlinePortal')) {
              colVal = row[column.name]
            } else {
              if ((row.hasOwnProperty('portalUrl') && row['portalUrl'] && row['portalUrl'] !== '') || (row.hasOwnProperty('thirdPartyPortalUrl') && row['thirdPartyPortalUrl'] && row['thirdPartyPortalUrl'] !== '')) {
                colVal = 1;
              }
            }
            tmpCardData[column.name] = colVal
          } else if (column.name === 'portalUrl' || column.name === 'thirdPartyPortalUrl') {
            if (column.name === 'portalUrl' && row['portalUrl'] && row['portalUrl'] !== '') {
              tmpCardData['isAcceptPortal'] = 1;
            }
            if (column.name === 'thirdPartyPortalUrl' && row['thirdPartyPortalUrl'] && row['thirdPartyPortalUrl'] !== '') {
              tmpCardData['isAccept3rdPartyPortal'] = 1;
            }
            tmpCardData[column.name] = row[column.name]
          } else if (cardProcessingFeeCols.includes(column.name)) {
            if ((row.hasOwnProperty('genericDollarProcessingFee') || row.hasOwnProperty('genericPercentProcessingFee'))) {
              if (row['genericDollarProcessingFee'] && row['genericPercentProcessingFee']) {
                isAllValidated = confirmByPass = isGenericFeeValid = false
                return
              }
              getCardGenericFeeDataForImport(tmpCardData, row, column.name, 'genericDollarProcessingFee', 'genericPercentProcessingFee', 'amexProcessingFeeType', 'visaProcessingFeeType', 'mastercardProcessingFeeType')
            } else {
              if ((row['amexProcessingDollarFeeValue'] && row['amexProcessingPercentFeeValue']) || (row['visaProcessingDollarFeeValue'] && row['visaProcessingPercentFeeValue']) || (row['mastercardProcessingDollarFeeValue'] && row['mastercardProcessingPercentFeeValue'])) {
                isAllValidated = confirmByPass = isGenericFeeValid = false
                return
              }
              getCardSpecificFeeDataForImport(tmpCardData, row, cardProcessingFeeCols, column.name, 'amexProcessingDollarFeeValue', 'amexProcessingPercentFeeValue', 'visaProcessingDollarFeeValue', 'visaProcessingPercentFeeValue', 'mastercardProcessingDollarFeeValue', 'mastercardProcessingPercentFeeValue', 'amexProcessingFeeType', 'visaProcessingFeeType', 'mastercardProcessingFeeType')
            }
          } else if (cardMinFeeCols.includes(column.name)) {
            if ((row.hasOwnProperty('genericDollarMinFee') || row.hasOwnProperty('genericPercentMinFee'))) {
              if (row['genericDollarMinFee'] && row['genericPercentMinFee']) {
                isAllValidated = confirmByPass = isGenericFeeValid = false
                return
              }
              getCardGenericFeeDataForImport(tmpCardData, row, column.name, 'genericDollarMinFee', 'genericPercentMinFee', 'amexMinPaymentFeeType', 'visaMinPaymentFeeType', 'mastercardMinPaymentFeeType')
            } else {
              if ((row['amexDollarMinPaymentFeeValue'] && row['amexPercentMinPaymentFeeValue']) || (row['visaDollarMinPaymentFeeValue'] && row['visaPercentMinPaymentFeeValue']) || (row['mastercardDollarMinPaymentFeeValue'] && row['mastercardPercentMinPaymentFeeValue'])) {
                isAllValidated = confirmByPass = isGenericFeeValid = false
                return
              }
              getCardSpecificFeeDataForImport(tmpCardData, row, cardMinFeeCols, column.name, 'amexDollarMinPaymentFeeValue', 'amexPercentMinPaymentFeeValue', 'visaDollarMinPaymentFeeValue', 'visaPercentMinPaymentFeeValue', 'mastercardDollarMinPaymentFeeValue', 'mastercardPercentMinPaymentFeeValue', 'amexMinPaymentFeeType', 'visaMinPaymentFeeType', 'mastercardMinPaymentFeeType')
            }
          } else if (cardMaxFeeCols.includes(column.name)) {
            if ((row.hasOwnProperty('genericDollarMaxFee') || row.hasOwnProperty('genericPercentMaxFee'))) {
              if (row['genericDollarMaxFee'] && row['genericPercentMaxFee']) {
                isAllValidated = confirmByPass = isGenericFeeValid = false
                return
              }
              getCardGenericFeeDataForImport(tmpCardData, row, column.name, 'genericDollarMaxFee', 'genericPercentMaxFee', 'amexMaxPaymentFeeType', 'visaMaxPaymentFeeType', 'mastercardMaxPaymentFeeType')
            } else {
              if ((row['amexDollarMaxPaymentFeeValue'] && row['amexPercentMaxPaymentFeeValue']) || (row['visaDollarMaxPaymentFeeValue'] && row['visaPercentMaxPaymentFeeValue']) || (row['mastercardDollarMaxPaymentFeeValue'] && row['mastercardPercentMaxPaymentFeeValue'])) {
                isAllValidated = confirmByPass = isGenericFeeValid = false
                return
              }
              getCardSpecificFeeDataForImport(tmpCardData, row, cardMaxFeeCols, column.name, 'amexDollarMaxPaymentFeeValue', 'amexPercentMaxPaymentFeeValue', 'visaDollarMaxPaymentFeeValue', 'visaPercentMaxPaymentFeeValue', 'mastercardDollarMaxPaymentFeeValue', 'mastercardPercentMaxPaymentFeeValue', 'amexMaxPaymentFeeType', 'visaMaxPaymentFeeType', 'mastercardMaxPaymentFeeType')
            }
          } else if (cardIncrementalFeeCols.includes(column.name)) {
            if ((row.hasOwnProperty('genericDollarIncrementalFee') || row.hasOwnProperty('genericPercentIncrementalFee'))) {
              if (row['genericDollarIncrementalFee'] && row['genericPercentIncrementalFee']) {
                isAllValidated = confirmByPass = isGenericFeeValid = false
                return
              }
              getCardGenericFeeDataForImport(tmpCardData, row, column.name, 'genericDollarIncrementalFee', 'genericPercentIncrementalFee', 'amexIncrementalFeeType', 'visaIncrementalFeeType', 'mastercardIncrementalFeeType')
            } else {
              if ((row['amexDollarIncrementalPaymentFeeValue'] && row['amexPercentIncrementalPaymentFeeValue']) || (row['visaDollarIncrementalPaymentFeeValue'] && row['visaPercentIncrementalPaymentFeeValue']) || (row['mastercardDollarIncrementalPaymentFeeValue'] && row['mastercardPercentIncrementalPaymentFeeValue'])) {
                isAllValidated = confirmByPass = isGenericFeeValid = false
                return
              }
              getCardSpecificFeeDataForImport(tmpCardData, row, cardIncrementalFeeCols, column.name, 'amexDollarIncrementalPaymentFeeValue', 'amexPercentIncrementalPaymentFeeValue', 'visaDollarIncrementalPaymentFeeValue', 'visaPercentIncrementalPaymentFeeValue', 'mastercardDollarIncrementalPaymentFeeValue', 'mastercardPercentIncrementalPaymentFeeValue', 'amexIncrementalFeeType', 'visaIncrementalFeeType', 'mastercardIncrementalFeeType')
            }
          } else {
            tmpCardData[column.name] = row[column.name]
          }
        })

        const tmpPaymentData = {}
        if (currentDataSource?.value === 'bulkUpdate' && selectedSupplierType === 'master') {
          tmpPaymentData['isAcceptCheckPayments'] = row['mastersPaymentIsAcceptCheckPayments']
          tmpPaymentData['isAcceptAchPayments'] = row['mastersPaymentIsAcceptAchPayments']
        } else {
          paymentColumns.forEach(column => {
            tmpPaymentData[column.name] = row[column.name]
          })
        }

        const tmpMerchantData = {}
        merchantColumns.forEach(column => {
          tmpMerchantData[column.name] = row[column.name]
        })

        const tmpSupplierEmails = {}
        if (currentDataSource?.value === 'bulkUpdate' && selectedSupplierType === 'master') {
          tmpSupplierEmails.emails = [];

          if (row['creditCardRemittanceEmail']) {
            tmpSupplierEmails.emails.push(
              ...row['creditCardRemittanceEmail'].split(',').map(email => ({
                type: 'Remittance',
                email: email.trim(),
              }))
            );
          }

          if (row['creditCardPaymentEmail']) {
            tmpSupplierEmails.emails.push(
              ...row['creditCardPaymentEmail'].split(',').map(email => ({
                type: 'Payment',
                email: email.trim(),
              }))
            );
          }
        } else {
          if (row['cardEmail']) {
            tmpSupplierEmails['email'] = row?.['cardEmail']
          }
        }

        returnData = {
          'supplier': tmpSupplierData,
          'supplierDetail': tmpSupplierDetailData,
          'card': tmpCardData,
          'payment': tmpPaymentData,
          'merchant': tmpMerchantData,
          'supplierEmails': tmpSupplierEmails,
          'supplierId': supplierId,
        }

        if (row['notes']) {
          returnData['notes'] = row?.['notes']
        }
      }
      return returnData
    })

    if (isTest) {
      await onConfirm(tmpData, matchedData.cols)
      setShowByPassModal(false)
    } else {
      if (currentDataSource?.value === 'bulkUpdate') {
        let compressedOriginal = null
        if (originalFile && !uploadedData.mainFileName) {
          compressedOriginal = await compressOriginalFile(originalFile);
        }
        validDataFileImport({ actionType: currentDataSource?.value, updatedValidData: tmpData, selectedSupplierType, compressedOriginal })
      } else {
        const chunkedTmpData = splitArrayInToChunks(tmpData, 500)
        dispatch(
          uploadFinalData(chunkedTmpData)
        ).then((res) => {
          const supplierIds = res?.allSuppliers.map(supplier => supplier.id)
          const masterSupplierIds = res?.allMasterSuppliers.map(supplier => supplier.masterId)
          dispatch(
            clearUploadData()
          )
          toast.show({
            title: 'Success',
            description: 'Uploaded your Supplier data successfully.',
          })

          if (masterSupplierIds.length > 0) {
            dispatch(
              addSupplierHistory({
                supplierId: masterSupplierIds,
                note: 'Master supplier imported by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>',
                noteType: 'changelog'
              })
            )
          }

          dispatch(
            addSupplierHistory({
              supplierId: supplierIds,
              note: 'Child supplier imported by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>',
              noteType: 'changelog'
            })
          ).then(() => {
            history.push({
              pathname: '/suppliers',
              state: { isJustFileUploaded: true },
            })
          })
        }).catch(() => {
          toast.show({
            title: 'Warning',
            description: 'Failed to upload supplier data to server.',
          })
        })
      }
    }
  }

  const dispatchDbMatch = async (data) => {
    let isAllValidated = true
    let phoneValid = true
    let isGenericFeeValid = true
    dispatch(uploadFinalDataStart())
    let compressedOriginal = null
    if (originalFile && !uploadedData.mainFileName) {
      compressedOriginal = await compressOriginalFile(originalFile);
    }
    const tmpData = data.map(row => {
      const tmpSupplierData = {}
      supplierAllColumns.forEach(column => {
        if (column.name === 'autoCreateMaster' && currentDomain?.roleId !== 3 && currentDomain?.roleName !== 'admin' && currentDomain?.roleId !== 2 && currentDomain?.roleName !== 'moderator') {
          return
        }

        if (column.name === 'phone') {
          let isExt = row[column.name] && row[column.name].toString().match(/x|ext|ext./)
          if (isExt && isExt.length > 0) {
            let parsePhone = row[column.name].split(isExt[0])
            tmpSupplierData[column.name] = parsePhone[0].trim()
            tmpSupplierData['phoneExtension'] = parsePhone[1].replace('.', '')
          } else {
            tmpSupplierData[column.name] = row[column.name]
            tmpSupplierData['phoneExtension'] = ''
          }
        } else if (column.name === 'state') {
          tmpSupplierData[column.name] = row[column.name]
          let stateCode = getAbbreviatedState(row?.abbreviatedState, row?.state)
          tmpSupplierData['abbreviatedState'] = stateCode
        }

        else {
          tmpSupplierData[column.name] = row[column.name]
        }
      })
      if (row['spend'] && (!spendTimeType || !spendTimeFrame)) {
        handleShowModal()
        isAllValidated = false
      }
      tmpSupplierData['spend'] = row?.['spend']
      tmpSupplierData['annualizedSpend'] = row?.['spend'] ? parseFloat(row?.['spend'] * spendTimeType?.rate / spendTimeFrame) : 0
      tmpSupplierData['paymentCount'] = row['paymentCount'] ? parseFloat(annualizedPaymentCount(spendTimeFrame, spendTimeType, row['paymentCount'])) : 0
      tmpSupplierData['lastInvoiceNumber'] = row['lastInvoiceNumber'] ? row['lastInvoiceNumber'] : null
      tmpSupplierData['spendTimeFrame'] = parseInt(spendTimeFrame)
      tmpSupplierData['spendTimeType'] = spendTimeType?.value

      const tmpSupplierDetailData = {}
      uploadSupplierDetailColumns.forEach(column => {
        if (column.name === 'contactDate') {
          if (typeof row[column.name] == 'string' && row[column.name].indexOf('/') !== -1) {
            tmpSupplierDetailData[column.name] = row[column.name]
          }
          else {
            if (row[column.name] === undefined)
              tmpSupplierDetailData[column.name] = ''
            else {
              var utc_days = Math.floor(row[column.name] - 25569);
              var utc_value = utc_days * 86400;
              var date_info = new Date(utc_value * 1000);

              var fractional_day = row[column.name] - Math.floor(row[column.name]) + 0.0000001;

              var total_seconds = Math.floor(86400 * fractional_day);

              var seconds = total_seconds % 60;

              total_seconds -= seconds;
              tmpSupplierDetailData[column.name] = `${date_info.getUTCFullYear()}/${date_info.getUTCMonth() + 1}/${date_info.getUTCDate()}`
            }
          }
        } else {
          tmpSupplierDetailData[column.name] = row[column.name]
        }
      })
      tmpSupplierDetailData['spend'] = row?.['spend']
      tmpSupplierDetailData['annualizedSpend'] = row?.['spend'] ? parseFloat(row?.['spend'] * spendTimeType?.rate / spendTimeFrame) : 0
      tmpSupplierDetailData['paymentCount'] = row['paymentCount'] ? parseFloat(annualizedPaymentCount(spendTimeFrame, spendTimeType, row['paymentCount'])) : 0
      tmpSupplierDetailData['lastInvoiceNumber'] = row['lastInvoiceNumber'] ? row['lastInvoiceNumber'] : null
      tmpSupplierDetailData['spendTimeFrame'] = parseInt(spendTimeFrame)
      tmpSupplierDetailData['spendTimeType'] = spendTimeType?.value

      const tmpCardData = {}
      cardColumns.forEach(column => {
        if (column.name === 'isAcceptVariableFee') {
          return
        }
        if (column.name === 'cardPaymentByPhoneValue') {
          let isExt = row[column.name] && row[column.name].toString().match(/x|ext|ext./)
          if (isExt && isExt.length > 0) {
            let parsePhone = row[column.name].split(isExt[0])
            tmpCardData[column.name] = parsePhone[0].trim()
            tmpCardData['cardPhoneExtension'] = parsePhone[1].replace('.', '')
          } else {
            tmpCardData[column.name] = row[column.name]
            tmpCardData['cardPhoneExtension'] = ''
          }
          if (tmpCardData[column.name]) {
            let test = tmpCardData[column.name]
            if ((/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(test) || /(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(test) || /(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(test))) {
              isAllValidated = true
              phoneValid = true
            } else {
              isAllValidated = false
              phoneValid = false
            }
            tmpCardData['isAcceptPOTSPhone'] = 1
          }
        } else if (cardVariableFeeCols.includes(column.name) && row.hasOwnProperty('isAcceptVariableFee')) {
          tmpCardData[column.name] = row['isAcceptVariableFee']
        } else if (cardMinPaymentColumns.includes(column.name) && row.hasOwnProperty('genericMinPayment')) {
          tmpCardData[column.name] = row['genericMinPayment']
        } else if (cardMaxPaymentColumns.includes(column.name) && row.hasOwnProperty('genericMaxPayment')) {
          tmpCardData[column.name] = row['genericMaxPayment']
        } else if (cardIncrementalPaymentColumns.includes(column.name) && row.hasOwnProperty('genericIncrementalPayment')) {
          tmpCardData[column.name] = row['genericIncrementalPayment']
        } else if (column.name === 'isAcceptCardPaymentByOnlinePortal') {
          let colVal = 0;
          if (row.hasOwnProperty('isAcceptCardPaymentByOnlinePortal')) {
            colVal = row[column.name]
          } else {
            if ((row.hasOwnProperty('portalUrl') && row['portalUrl'] && row['portalUrl'] !== '') || (row.hasOwnProperty('thirdPartyPortalUrl') && row['thirdPartyPortalUrl'] && row['thirdPartyPortalUrl'] !== '')) {
              colVal = 1;
            }

          }
          tmpCardData[column.name] = colVal
        } else if (column.name === 'portalUrl' || column.name === 'thirdPartyPortalUrl') {
          if (column.name === 'portalUrl' && row['portalUrl'] && row['portalUrl'] !== '') {
            tmpCardData['isAcceptPortal'] = 1;
          }
          if (column.name === 'thirdPartyPortalUrl' && row['thirdPartyPortalUrl'] && row['thirdPartyPortalUrl'] !== '') {
            tmpCardData['isAccept3rdPartyPortal'] = 1;
          }
          tmpCardData[column.name] = row[column.name]
        } else if (cardProcessingFeeCols.includes(column.name)) {
          if ((row.hasOwnProperty('genericDollarProcessingFee') || row.hasOwnProperty('genericPercentProcessingFee'))) {
            if (row['genericDollarProcessingFee'] && row['genericPercentProcessingFee']) {
              isAllValidated = isGenericFeeValid = false
              return
            }
            getCardGenericFeeDataForImport(tmpCardData, row, column.name, 'genericDollarProcessingFee', 'genericPercentProcessingFee', 'amexProcessingFeeType', 'visaProcessingFeeType', 'mastercardProcessingFeeType')
          } else {
            if ((row['amexProcessingDollarFeeValue'] && row['amexProcessingPercentFeeValue']) || (row['visaProcessingDollarFeeValue'] && row['visaProcessingPercentFeeValue']) || (row['mastercardProcessingDollarFeeValue'] && row['mastercardProcessingPercentFeeValue'])) {
              isAllValidated = isGenericFeeValid = false
              return
            }
            getCardSpecificFeeDataForImport(tmpCardData, row, cardProcessingFeeCols, column.name, 'amexProcessingDollarFeeValue', 'amexProcessingPercentFeeValue', 'visaProcessingDollarFeeValue', 'visaProcessingPercentFeeValue', 'mastercardProcessingDollarFeeValue', 'mastercardProcessingPercentFeeValue', 'amexProcessingFeeType', 'visaProcessingFeeType', 'mastercardProcessingFeeType')
          }
        } else if (cardMinFeeCols.includes(column.name)) {
          if ((row.hasOwnProperty('genericDollarMinFee') || row.hasOwnProperty('genericPercentMinFee'))) {
            if (row['genericDollarMinFee'] && row['genericPercentMinFee']) {
              isAllValidated = isGenericFeeValid = false
              return
            }
            getCardGenericFeeDataForImport(tmpCardData, row, column.name, 'genericDollarMinFee', 'genericPercentMinFee', 'amexMinPaymentFeeType', 'visaMinPaymentFeeType', 'mastercardMinPaymentFeeType')
          } else {
            if ((row['amexDollarMinPaymentFeeValue'] && row['amexPercentMinPaymentFeeValue']) || (row['visaDollarMinPaymentFeeValue'] && row['visaPercentMinPaymentFeeValue']) || (row['mastercardDollarMinPaymentFeeValue'] && row['mastercardPercentMinPaymentFeeValue'])) {
              isAllValidated = isGenericFeeValid = false
              return
            }
            getCardSpecificFeeDataForImport(tmpCardData, row, cardMinFeeCols, column.name, 'amexDollarMinPaymentFeeValue', 'amexPercentMinPaymentFeeValue', 'visaDollarMinPaymentFeeValue', 'visaPercentMinPaymentFeeValue', 'mastercardDollarMinPaymentFeeValue', 'mastercardPercentMinPaymentFeeValue', 'amexMinPaymentFeeType', 'visaMinPaymentFeeType', 'mastercardMinPaymentFeeType')
          }
        } else if (cardMaxFeeCols.includes(column.name)) {
          if ((row.hasOwnProperty('genericDollarMaxFee') || row.hasOwnProperty('genericPercentMaxFee'))) {
            if (row['genericDollarMaxFee'] && row['genericPercentMaxFee']) {
              isAllValidated = isGenericFeeValid = false
              return
            }
            getCardGenericFeeDataForImport(tmpCardData, row, column.name, 'genericDollarMaxFee', 'genericPercentMaxFee', 'amexMaxPaymentFeeType', 'visaMaxPaymentFeeType', 'mastercardMaxPaymentFeeType')
          } else {
            if ((row['amexDollarMaxPaymentFeeValue'] && row['amexPercentMaxPaymentFeeValue']) || (row['visaDollarMaxPaymentFeeValue'] && row['visaPercentMaxPaymentFeeValue']) || (row['mastercardDollarMaxPaymentFeeValue'] && row['mastercardPercentMaxPaymentFeeValue'])) {
              isAllValidated = isGenericFeeValid = false
              return
            }
            getCardSpecificFeeDataForImport(tmpCardData, row, cardMaxFeeCols, column.name, 'amexDollarMaxPaymentFeeValue', 'amexPercentMaxPaymentFeeValue', 'visaDollarMaxPaymentFeeValue', 'visaPercentMaxPaymentFeeValue', 'mastercardDollarMaxPaymentFeeValue', 'mastercardPercentMaxPaymentFeeValue', 'amexMaxPaymentFeeType', 'visaMaxPaymentFeeType', 'mastercardMaxPaymentFeeType')
          }
        } else if (cardIncrementalFeeCols.includes(column.name)) {
          if ((row.hasOwnProperty('genericDollarIncrementalFee') || row.hasOwnProperty('genericPercentIncrementalFee'))) {
            if (row['genericDollarIncrementalFee'] && row['genericPercentIncrementalFee']) {
              isAllValidated = isGenericFeeValid = false
              return
            }
            getCardGenericFeeDataForImport(tmpCardData, row, column.name, 'genericDollarIncrementalFee', 'genericPercentIncrementalFee', 'amexIncrementalFeeType', 'visaIncrementalFeeType', 'mastercardIncrementalFeeType')
          } else {
            if ((row['amexDollarIncrementalPaymentFeeValue'] && row['amexPercentIncrementalPaymentFeeValue']) || (row['visaDollarIncrementalPaymentFeeValue'] && row['visaPercentIncrementalPaymentFeeValue']) || (row['mastercardDollarIncrementalPaymentFeeValue'] && row['mastercardPercentIncrementalPaymentFeeValue'])) {
              isAllValidated = isGenericFeeValid = false
              return
            }
            getCardSpecificFeeDataForImport(tmpCardData, row, cardIncrementalFeeCols, column.name, 'amexDollarIncrementalPaymentFeeValue', 'amexPercentIncrementalPaymentFeeValue', 'visaDollarIncrementalPaymentFeeValue', 'visaPercentIncrementalPaymentFeeValue', 'mastercardDollarIncrementalPaymentFeeValue', 'mastercardPercentIncrementalPaymentFeeValue', 'amexIncrementalFeeType', 'visaIncrementalFeeType', 'mastercardIncrementalFeeType')
          }
        } else {
          tmpCardData[column.name] = row[column.name]
        }
      })
      const tmpPaymentData = {}
      paymentColumns.forEach(column => {
        tmpPaymentData[column.name] = row[column.name]
      })

      const tmpSupplierEmails = {}
      if (row['cardEmail']) {
        tmpSupplierEmails['email'] = row?.['cardEmail']
      }

      let returnData = {
        'supplier': tmpSupplierData,
        'supplierDetail': tmpSupplierDetailData,
        'card': tmpCardData,
        'payment': tmpPaymentData,
        'supplierEmails': tmpSupplierEmails
      }

      if (row['notes']) {
        returnData['notes'] = row?.['notes']
      }
      return returnData
    })

    if (!isAllValidated) {
      setShowByPassModal(false)
      if (!phoneValid) {
        toast.show({
          title: 'Warning',
          description: 'There is Validation Error in Phone Number!'
        })
      } else if (!isGenericFeeValid) {
        toast.show({
          title: 'Danger',
          description: 'There shouldn\'t be data for both Generic Dollar Fee and Generic Percent Fee for one Supplier!'
        })
        return
      } else {
        toast.show({
          title: 'Warning',
          description: 'There is Validation Error!'
        })
      }
      dispatch(uploadFinalDataFailed())
      return
    }

    if (isTest) {
      await onConfirm(tmpData, matchedData.cols)
      setShowByPassModal(false)
    } else {

      const listData = {
        companyName: dbMatchValues.companyName?.name || '',
        primaryContact: dbMatchValues.primaryContact,
        contactPhone: dbMatchValues.contactPhone,
        contactEmail: dbMatchValues.contactEmail,
        nameUse: dbMatchValues.nameUse,
        partnerId: partnerNames.find(partner => partner?.partnerName === dbMatchValues.partnerName)?.id,
      };

      const partnerName = dbMatchValues.partnerName;
      const callingScriptId = dbMatchValues?.callingScriptId?.value;
      const listId = dbMatchValues?.listId || null

      validDataFileImport({ actionType: currentDataSource?.value, updatedValidData: tmpData, listData, partnerName, callingScriptId, listId, compressedOriginal })
    }
  }

  const fileErrorCloseHandler = () => {
    setShowFileError(false)
  }

  const validDataFileImport = async ({ actionType, updatedValidData, selectedSupplierType = '', listData, partnerName, callingScriptId, listId = null, compressedOriginal = null }) => {
    const jsonContent = JSON?.stringify(updatedValidData, null, 2);
    let fileName = `${actionType?.toLowerCase()}${selectedSupplierType ? `_${selectedSupplierType.toLowerCase()}` : ''}_mapped_file`;
    const formData = new FormData();
    if (compressedOriginal && !uploadedData.mainFileName) {
      formData.append('originalFile', compressedOriginal, `originalFile.gz`);
    }
    formData.append('originalFileName', uploadedData.mainFileName || null);

    if (actionType === 'bulkUpdate') {
      formData.append('type', actionType)
      formData.append('supplierType', selectedSupplierType)
    } else {
      formData.append('dataLength', updatedValidData?.length)
      formData.append('type', actionType)
      formData.append('listData', JSON?.stringify(listData))
      formData.append('partnerName', partnerName)
      formData.append('callingScriptId', callingScriptId)
      formData.append('listId', uploadedData.uploadedListId ? uploadedData.uploadedListId : listId)
    }

    const reader = new FileReader();
    let compressedBlob = null
    const compressed = await Pako.gzip(jsonContent);
    compressedBlob = new Blob([compressed], { type: 'application/gzip' });
    const fileFormData = new FormData();
    fileFormData.append('file', compressedBlob, `${fileName}.gz`);
    await dispatch(
      uploadFileUsingMulter(fileFormData)
    ).then(async (response) => {
      formData.append('mappedFile', response?.data?.file || null);
      formData.append('mappedFileName', response?.data?.fileName || null);
    }).catch(err => {
      dispatch(uploadFinalDataFailed())
      return
    })

    dispatch(
      importFileData(formData, actionType, selectedSupplierType, (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        console.log(`Upload progress: ${percentCompleted}%`);
      })
    ).then(async (response) => {
      if (uploadedData.processedRows < uploadedData.totalRows) {
        let filterDataNew = await handleFileChosen(originalFile);
        dispatch(
          uploadData({
            cols: filterDataNew.cols,
            data: filterDataNew.subsetTableData,
            fileName: filterDataNew.fileName,
            processedRows: filterDataNew.processedRows,
            totalRows: uploadedData.totalRows,
            uploadedListId: response?.data?.listId,
            mainFileName: response?.data?.mainFileName
          })
        );
        setProcessedRecords(filterDataNew.processedRows);
        dispatch(
          matchUploadedData(colWithStatus)
        )
        dispatch(uploadFinalDataFailed())
      } else {
        dispatch(uploadFinalDataFailed())
        dispatch(
          clearUploadData()
        )
        updateDataSource(null)
        if (actionType === 'bulkUpdate') {
          history.push({
            pathname: '/suppliers',
            state: { isJustFileUploaded: true },
          })
        }
        if (actionType === 'list') {
          history.push({
            pathname: '/lists'
          })
        }
        toast.show({
          title: 'Success',
          description: response?.data?.message,
        })
      }
    }).catch((error) => {
      dispatch(uploadFinalDataFailed())
      toast.show({
        title: 'Warning',
        description: error
      })
    })
  };

  const handleFileChosen = async (file) => {
    if (!file || !["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv"].includes(file.type)) {
      toast.show({
        title: 'Warning',
        description: 'File type should be .csv, .xls, or .xlsx!'
      });
      return;
    }
    let data;
    if (file.type === 'text/csv') {
      data = await readCsvFileInChunks(file);
    } else {
      data = await readExcelFileInChunks(file);
    }

    if (data && data.rows.length > 0) {
      setTotalRecords(data.rows.length);
      return loadUploadedFileContent(data.rows, data.columns, file.name);
    }
  };

  const loadUploadedFileContent = (data, cols, fileName) => {
    if (currentDataSource?.value === 'bulkUpdate') {
      const hasPlaceholder = (value) => {
        const placeholders = ["#", "string", "example@gmail.com", "true/false"];
        return placeholders.some(placeholder => String(value).includes(placeholder));
      };
      const shouldRemoveFirstElement = Object.values(data[0]).some(hasPlaceholder);
      if (shouldRemoveFirstElement) {
        data.shift();
      }
    }
    const reindexedCols = [...cols];
    const filteredCols = reindexedCols.filter(item => item !== undefined);
    const chunkSize = 50000;  // Manage the chunk size to be displaid and uploaded from preview table
    const startIndex = uploadedData.processedRows;
    setStartIndexData(startIndex)
    const endIndex = Math.min(startIndex + chunkSize, uploadedData?.totalRows);

    const subsetTableData = [];
    for (let i = startIndex; i < endIndex; i++) {
      const row = data[i];
      const rowData = {};
      filteredCols.forEach((col, index) => {
        rowData[col] = row[index];
      });
      subsetTableData.push(rowData);
    }

    let tableDataDetails = {
      cols: filteredCols,
      subsetTableData,
      fileName,
      processedRows: endIndex
    };
    return tableDataDetails;
  };

  const readExcelFileInChunks = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      const workbook = new ExcelJS.Workbook();
      let rows = [];
      let columns = [];

      reader.onload = async (e) => {
        const buffer = e.target.result;
        await workbook.xlsx.load(buffer);
        const worksheet = workbook.worksheets[0];
        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          if (rowNumber === 1) {
            columns = row.values.slice(1);
          } else {
            rows.push(row.values.slice(1));
          }
        });
        resolve({ rows, columns });
      };

      reader.readAsArrayBuffer(file);
    });
  };

  const readCsvFileInChunks = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      let offset = 0;
      let rows = [];
      let columns = [];
      let remaining = '';

      const readNextChunk = () => {
        const chunk = file.slice(offset, offset + CHUNK_SIZE);
        reader.readAsText(chunk);
      };

      reader.onload = (e) => {
        const text = remaining + e.target.result;
        const lines = text.split('\n');

        // Store incomplete line for the next chunk
        if (!text.endsWith('\n')) {
          remaining = lines.pop();
        } else {
          remaining = '';
        }

        if (offset === 0 && lines.length > 0) {
          columns = parseCsvRow(lines.shift());
        }

        for (const line of lines) {
          if (line.trim()) {
            rows.push(parseCsvRow(line));
          }
        }

        offset += CHUNK_SIZE;

        if (offset < file.size) {
          readNextChunk();
        } else {
          if (remaining.trim()) {
            rows.push(parseCsvRow(remaining));
          }
          resolve({ rows, columns });
        }
      };

      reader.onerror = (err) => {
        reject(err);
      };

      readNextChunk();
    });
  };

  const parseCsvRow = (row) => {
    const result = [];
    let insideQuotes = false;
    let currentField = '';
    for (let i = 0; i < row.length; i++) {
      const char = row[i];
      if (char === '"') {
        insideQuotes = !insideQuotes;
      } else if (char === ',' && !insideQuotes) {
        result.push(currentField.trim());
        currentField = '';
      } else {
        currentField += char;
      }
    }
    result.push(currentField.trim());
    return result;
  };

  const compressOriginalFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const fileContent = e.target.result;
          const compressedData = Pako.gzip(fileContent);
          const originalCompressedBlob = new Blob([compressedData], { type: 'application/gzip' });
          resolve(originalCompressedBlob);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = (err) => reject(err);
      reader.readAsText(file); // Use readAsArrayBuffer for binary files
    });
  };

  return (
    <div className={`match-tab${isUploading ? ' position-relative loading' : ''}`}>
      {isUploading && <Loader center={true} vertical={true} size="md" />}
      <div className="match-header">
      </div>
      <div className="match-tab-action">
        <button type="button" className="btn btn-white back" onClick={() => { onGoBack('match') }}>
          Go Back
        </button>

        <div className="progress-container d-flex align-items-center report_heading gap-3">
          <div className="processed-records fs-4">
            Processing Records: {startIndexData + 1} - {processedRecords} / {totalRecords}
          </div>
          <button type="button" className="btn btn-black continue" onClick={isAdminOrModerator ? fileValidationHandler : handleUploadFinalData} disabled={isUploading}>
            Confirm
          </button>
          <button type="button" className="btn text-white bg-yellow continue border border-yellow" onClick={skipTableRecord}>
            Skip
          </button>
        </div>

      </div>
      {
        showFileError && (
          <ModalComponent
            size='md'
            modalTitle='Found Error'
            open={showFileError}
            handleClose={fileErrorCloseHandler}
          >
            <div className={`w-100${isUploading ? ' position-relative loading' : ''}`}>
              {isUploading && <LoaderComponent />}
              <div>
                <p className='fs-4 fw-bold'>Total Records: <span>{tableData.length}</span></p>
                <p className='fs-4 fw-bold'>Total Records With Errors: <span>{countInvalidRecords}</span></p>
              </div>
              <div className='d-flex column-gap-3'>
                <button className='report_small_button_grey' onClick={fileErrorCloseHandler}>Cancel</button>
                <button className='report_small_button_success fs-4 px-3' style={{ width: 'auto' }} onClick={exportInvalidRecords}>Export Bad Records And Confirm</button>
              </div>
            </div>
          </ModalComponent>
        )
      }
      <div className="card mt-3">
        <div className="card-content search-bar flex flex-wrap justify-space-between algin-center">
          <div className="search-input-container">
            {
              searchColumns.map(column => (
                <div className="search-input-item" key={column.label}>
                  <input type="text" className="search-input h4" placeholder={column.label} onChange={(e) => { handleChangeSearch(e.target.value, column.name) }} />
                </div>
              ))
            }
          </div>
          <div className="search-action">
            <button type="button" className="btn btn-gray clear" onClick={handleClickRemoveSearch}>
              Clear
            </button>
          </div>
        </div>
      </div>
      <div className={`card match-content${(isUploading || isDBMatching) ? ' position-relative loading' : ''}`}>
        {(isUploading || isDBMatching) && <LoaderComponent />}
        <div className="card-content">
          <div className="toolbar flex-wrap gap-3">
            <div className="item">
              <ToggleButton onChange={handleChangeProblemToggle} checked={showOnlyIssuedRows} />
              <span className='toggle-item-text'>Only show rows with problems</span>
            </div>
            <div className="item ps-0">
              <ToggleButton onChange={handleChangeModifiedToggle} checked={showOnlyModifiedRows} />
              <span className='toggle-item-text'>Show modifications</span>
            </div>
            <div className="item ps-0">
              <ToggleButton onChange={handleChangeImportableToggle} checked={showAllImportableColumns} />
              <span className='toggle-item-text'>Show All Importable Columns</span>
            </div>
            <div className="item action ps-0">
              <button type="button" className="btn btn-green" onClick={handleSaveEdit}>
                Save Changes
              </button>
              <button type="button" className="btn btn-green" onClick={handleCancelEdit}>
                Cancel Changes
              </button>
            </div>
          </div>
          {
            useMemo(() => (
              <PreviewTable
                tableHeader={tableHeader}
                filteredTableData={filteredTableData}
                editingIds={editingIds}
                onChange={handleChange}
                columns={previewColumns}
                onEditState={handleEditState}
              />
            ), [filteredTableData, tableHeader, editingIds, previewColumns, handleChange, handleEditState])
          }
          <div className="pagination">
            <Pagination
              prev
              next
              first
              last
              showInfo
              maxButtons={5}
              lengthMenu={[
                {
                  label: '5',
                  value: 5,
                },
                {
                  label: '10',
                  value: 10,
                },
              ]}
              displayLength={limit}
              total={tableLength || 0}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLength={handleChangeLimit}
            />
          </div>
        </div>
      </div>
      <SpendInfoModal
        onClose={handleCloseModal}
        show={showModal}
        spendTimeFrame={spendTimeFrame}
        spendTimeType={spendTimeType}
        onUpload={handleSetSpendDuration}
      />

      {showByPassModal && (
        <ByPassModal show={showByPassModal} onClose={ByPassModalClose} onConfirm={ByPassModalConfirm} />
      )}

    </div>
  )
}

export default PreviewComponent
